export const ONBOARDING_STEPS = {
  training: { label: 'Complete Training Videos', order: 1 },
  form: { label: 'Complete Onboarding Form', order: 2 },
  scheduleCall: { label: 'Schedule 1:1 Onboarding Call', order: 3 },
  completeCall: { label: 'Complete 1:1 Onboarding Call', order: 4 },
  cardOnFile: { label: 'Setup Card on File', order: 5 },
  returnKit: { label: 'Return Practitioner Kit', order: 6 },
  personalScanReview: { label: 'Personal Scan Review Call', order: 7 },
};